import Vue from 'vue';
import Router from 'vue-router';
import home from '@/components/home';
import login from '@/components/login/login';
import orderQuery from '@/components/order/orderQuery';
import applyClaim from '@/components/order/applyClaim';
import learn from '@/components/order/learn';
import signer from '@/components/sign/signer';
import FAQ from '@/components/order/FAQ';
import myOrder from '@/components/order/myOrderInfo';
import settlementInfo from '@/components/order/settlementInfo';
import index from '@/views/index'
import axios from 'axios';
import {Config, ROUTES} from '../components/common/api';


//驾校端页面
import dirverLogin from '@/views/driverSchool/login'
import checkType from '@/views/driverSchool/checkType'
import toubaoManager from '@/views/driverSchool/toubaoManager'
import toubaoView from '@/views/driverSchool/toubaoView'
import toubaoStudent from '@/views/driverSchool/toubaoStudent'
import myOrders from '@/views/driverSchool/myOrders'
Vue.use(Router);

const router = new Router({
  base: '/newBaoPublic',
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash
      };
    }
  },
  routes: [
    {
      path: '/dirverLogin',
      name: 'dirverLogin',
      component: dirverLogin,
      meta: {
        requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
        allowBack: false
      }
    },
    {
      path: '/checkType',
      name: 'checkType',
      component: checkType,
      meta: {
        requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
        allowBack: false
      }
    },
    {
      path: '/toubaoManager',
      name: 'toubaoManager',
      component: toubaoManager,
      meta: {
        requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
        allowBack: false
      }
    }, {
      path: '/toubaoView',
      name: 'toubaoView',
      component: toubaoView,
      meta: {
        requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
        allowBack: false
      }
    },{
      path: '/toubaoStudent',
      name: 'toubaoStudent',
      component: toubaoStudent,
      meta: {
        requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
        allowBack: false
      }
    },{
      path: '/myOrders',
      name: 'myOrders',
      component: myOrders,
      meta: {
        requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
        allowBack: false
      }
    },





    {
    path: '/index',
    name: 'home',
    component: home,
    meta: {
      allowBack: false
    }
  },{
    path: '/login',
    name: 'login',
    component: login,
    meta: {
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      allowBack: true
    }
  },
    {
    path: '/orderQuery',
    name: 'orderQuery',
    component: orderQuery,
    meta: {
      requireAuth: true,
      allowBack: false
    }
  },
    {
    path: '/',
    name: 'index',
    component: index,
    meta: {
      requireAuth: true,
      allowBack: false
    }
  },
    {
      path: '/myOrder/:credId',
      name: 'myOrder',
      component: myOrder,
      meta: {
        requireAuth: true,
        allowBack: false
      }
    },{
      path: '/settlementInfo/:credId',
      name: 'settlementInfo',
      component: settlementInfo,
      meta: {
        requireAuth: true,
        allowBack: false
      }
    },
    {
    path: '/learn',
    name: 'learn',
    component: learn,
    meta: {
      requireAuth: true,
      allowBack: true
    }
  },{
    path: '/signer',
    name: 'signer',
    component: signer,
    meta: {
      requireAuth: true,
      allowBack: true
    }
  },{
    path: '/applyClaim',
    name: 'applyClaim',
    component: applyClaim,
    meta: {
      requireAuth: true,
      allowBack: false
    }
  },{
    path: '/FAQ',
    name: 'FAQ',
    component: FAQ,
    meta: {
      requireAuth: true,
      allowBack: false
    }
  }]
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js